import React, { useEffect } from 'react';
import { useSpring, SpringConfig } from '@react-spring/web';
import { animateInSpringConfig } from 'components/Animations/SpringProperties/SpringProperties';

export interface IAnimateInProps {
  animationReady: boolean;
}

export const useAnimateInSpring = (animateInStatus: boolean, customSpringConfig: SpringConfig = {}) => {
  let springConfig: SpringConfig = animateInSpringConfig;

  if (customSpringConfig !== {})
    springConfig = customSpringConfig;

  const [animateInSpring, setAnimateInSpring] = useSpring(() => ({
    active: 0,
    config: springConfig,
  }));

  useEffect(() => {
    setAnimateInSpring({
      active: animateInStatus ? 1 : 0,
    });
  }, [animateInStatus]);

  return animateInSpring;
};
